<template>
  <div class="tax-table-wrap" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>增值税及附加税费申报表<br />（小规模纳税人适用）</dt>

      <dd>
        <div>
          纳税人名称（公章）：{{ staticConfig.companyName }}<br />
          纳税人识别号（统一社会信用代码）：<br />
          {{ staticConfig.creditCode }}
        </div>

        <div>
          税款所属期：{{ staticConfig.taxStartTime }} ~ {{ staticConfig.taxEndTime }}<br />
          填报日期：{{ staticConfig.fillFormDate }}
        </div>

        <div>单位：元至角分</div>
      </dd>
    </dl>

    <div class="tax-table-body">
      <table>
        <tbody>
          <tr>
            <td rowspan="16" style="width: 50px; writing-mode: vertical-rl">一 、计税依据</td>
            <td rowspan="2" style="width: 350px">项目</td>
            <td rowspan="2">栏次</td>
            <td colspan="2">本期数</td>
            <td colspan="2">本年累计</td>
          </tr>
          <tr>
            <td>货物及劳务</td>
            <td>服务、不动产<br />和无形资产</td>
            <td>货物及劳务</td>
            <td>服务、不动产<br />和无形资产</td>
          </tr>
          <tr>
            <td>（一）应征增值税不含税销售额（3%征收率）</td>
            <td>1</td>
            <td>
              <taxQue :data="data.v1x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td>
              <el-input-number v-model.trim="data.v1x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v1x3.value) }}</td>
            <td>{{ parseFloatNum(data.v1x4.value) }}</td>
          </tr>
          <tr>
            <td>
              <p>增值税专用发票不含税销售额</p>
            </td>
            <td>2</td>
            <td>
              <taxQue :data="data.v2x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td>
              <el-input-number v-model.trim="data.v2x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v2x3.value) }}</td>
            <td>{{ parseFloatNum(data.v2x4.value) }}</td>
          </tr>
          <tr>
            <td>
              <p>其他增值税发票不含税销售额</p>
            </td>
            <td>3</td>
            <td>
              <el-input-number v-model.trim="data.v3x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v3x3.value) }}</td>
            <td>{{ parseFloatNum(data.v3x4.value) }}</td>
          </tr>
          <tr>
            <td>（二）应征增值税不含税销售额（5%征收率）</td>
            <td>4</td>
            <td>---</td>
            <td>
              <el-input-number v-model.trim="data.v4x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>{{ parseFloatNum(data.v4x4.value) }}</td>
          </tr>
          <tr>
            <td>
              <p>增值税专用发票不含税销售额</p>
            </td>
            <td>5</td>
            <td>---</td>
            <td>
              <el-input-number v-model.trim="data.v5x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>{{ parseFloatNum(data.v5x4.value) }}</td>
          </tr>
          <tr>
            <td>
              <p>其他增值税发票不含税销售额</p>
            </td>
            <td>6</td>
            <td>---</td>
            <td>
              <el-input-number v-model.trim="data.v6x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>{{ parseFloatNum(data.v6x4.value) }}</td>
          </tr>
          <tr>
            <td>（三）销售使用过的固定资产不含税销售额</td>
            <td>7(7≥8)</td>
            <td>
              <el-input-number v-model.trim="data.v7x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>{{ parseFloatNum(data.v7x3.value) }}</td>
            <td>---</td>
          </tr>
          <tr>
            <td>其中：其他增值税发票不含税销售额</td>
            <td>8</td>
            <td>
              <el-input-number v-model.trim="data.v8x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>{{ parseFloatNum(data.v8x3.value) }}</td>
            <td>---</td>
          </tr>
          <tr>
            <td>（四）免税销售额</td>
            <td>9=10+11+12</td>
            <td>{{ parseFloatNum(data.v9x1.value) }}</td>
            <td>{{ parseFloatNum(data.v9x2.value) }}</td>
            <td>{{ parseFloatNum(data.v9x3.value) }}</td>
            <td>{{ parseFloatNum(data.v9x4.value) }}</td>
          </tr>
          <tr>
            <td>其中：小微企业免税销售额</td>
            <td>10</td>
            <td>
              <taxQue :data="data.v10x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v10x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v10x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v10x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td>
              <el-input-number v-model.trim="data.v10x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v10x3.value) }}</td>
            <td>{{ parseFloatNum(data.v10x4.value) }}</td>
          </tr>
          <tr>
            <td>未达起征点销售额</td>
            <td>11</td>
            <td>
              <el-input-number v-model.trim="data.v11x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v11x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v11x3.value) }}</td>
            <td>{{ parseFloatNum(data.v11x4.value) }}</td>
          </tr>
          <tr>
            <td>其他免税销售额</td>
            <td>12</td>
            <td>
              <el-input-number v-model.trim="data.v12x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v12x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v12x3.value) }}</td>
            <td>{{ parseFloatNum(data.v12x4.value) }}</td>
          </tr>
          <tr>
            <td>（五）出口免税销售额</td>
            <td>13(13≥14)</td>
            <td>
              <el-input-number v-model.trim="data.v13x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v13x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v13x3.value) }}</td>
            <td>{{ parseFloatNum(data.v13x4.value) }}</td>
          </tr>
          <tr>
            <td>其中：其他增值税发票不含税销售额</td>
            <td>14</td>
            <td>
              <el-input-number v-model.trim="data.v14x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v14x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v14x3.value) }}</td>
            <td>{{ parseFloatNum(data.v14x4.value) }}</td>
          </tr>
          <tr>
            <td rowspan="8" style="writing-mode: vertical-rl">二、税款计算</td>
            <td>本期应纳税额</td>
            <td>15</td>
            <td>
              <!-- 计算 v1*3% -->
              {{ parseFloatNum(data.v15x1.value) }}
              <!-- <el-input-number v-model.trim="data.v15x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
            <td>
              <!-- 计算 v1*3% -->
              {{ parseFloatNum(data.v15x2.value) }}
              <!-- <el-input-number v-model.trim="data.v15x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
            <td>
              {{ parseFloatNum(data.v15x3.value) }}
            </td>
            <td>{{ parseFloatNum(data.v15x4.value) }}</td>
          </tr>
          <tr>
            <td>本期应纳税额减征额</td>
            <td>16</td>
            <td>
              <!-- 自动关联明细表 -->
              {{ parseFloatNum(data.v16x1.value) }}
              <!-- <el-input-number v-model.trim="data.v16x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
            <td>
              {{ parseFloatNum(data.v16x2.value) }}
              <!-- <el-input-number v-model.trim="data.v16x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
            <td>
              {{ parseFloatNum(data.v16x3.value) }}
            </td>
            <td>{{ parseFloatNum(data.v16x4.value) }}</td>
          </tr>
          <tr>
            <td>本期免税额</td>
            <td>17</td>
            <td>
              {{ parseFloatNum(data.v17x1.value) }}
            </td>
            <td>
              {{ parseFloatNum(data.v17x2.value) }}
            </td>
            <td>{{ parseFloatNum(data.v17x3.value) }}</td>
            <td>{{ parseFloatNum(data.v17x4.value) }}</td>
          </tr>
          <tr>
            <td>其中：小微企业免税额</td>
            <td>18</td>
            <td>
              <!-- v12*3% -->
              {{ parseFloatNum(data.v18x1.value) }}
              <!-- <el-input-number v-model.trim="data.v18x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
            <td>
              <!-- v12*3% -->
              {{ parseFloatNum(data.v18x2.value) }}
              <!-- <el-input-number v-model.trim="data.v18x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /> -->
            </td>
            <td>
              {{ parseFloatNum(data.v18x3.value) }}
            </td>
            <td>{{ parseFloatNum(data.v18x4.value) }}</td>
          </tr>
          <tr>
            <td>未达起征点免税额</td>
            <td>19</td>
            <td>
              <el-input-number v-model.trim="data.v19x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v19x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v19x3.value) }}</td>
            <td>{{ parseFloatNum(data.v19x4.value) }}</td>
          </tr>
          <tr>
            <td>应纳税额合计</td>
            <td>20=15-16</td>
            <td>
              <!-- v15-v16 -->
              {{ parseFloatNum(data.v20x1.value) }}
            </td>
            <td>{{ parseFloatNum(data.v20x2.value) }}</td>
            <td>
              <!-- v15-v16 -->
              {{ parseFloatNum(data.v20x3.value) }}
            </td>
            <td>{{ parseFloatNum(data.v20x4.value) }}</td>
          </tr>
          <tr>
            <td>本期预缴税额</td>
            <td>21</td>
            <td>
              <el-input-number v-model.trim="data.v21x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v21x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>---</td>
            <td>---</td>
          </tr>
          <tr>
            <td>本期应补（退）税额</td>
            <td>22=20-21</td>
            <td>
              <taxQue :data="data.v22x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v22x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v22x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v22x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td>{{ parseFloatNum(data.v22x2.value) }}</td>
            <td>---</td>
            <td>---</td>
          </tr>
          <tr>
            <td rowspan="3" style="writing-mode: vertical-rl">三、附加税费</td>
            <td>城市维护建设税本期应补（退）税额</td>
            <td>23</td>
            <td colspan="2">
              <!-- 自动关联附表二 -->
              {{ parseFloatNum(data.v23x1.value) }}
            </td>
            <td colspan="2">{{ parseFloatNum(data.v23x2.value) }}</td>
          </tr>
          <tr>
            <td>教育费附加本期应补（退）费额</td>
            <td>24</td>
            <td colspan="2">
              <!-- 自动关联附表二 -->
              {{ parseFloatNum(data.v24x1.value) }}
            </td>
            <td colspan="2">{{ parseFloatNum(data.v24x2.value) }}</td>
          </tr>
          <tr>
            <td>地方教育附加本期应补（退）费额</td>
            <td>25</td>
            <td colspan="2">
              <!-- 自动关联附表二 -->
              {{ parseFloatNum(data.v25x1.value) }}
            </td>
            <td colspan="2">{{ parseFloatNum(data.v25x2.value) }}</td>
          </tr>
          <tr>
            <td colspan="2" rowspan="4">纳税人或代理人声明：<br />本纳税申报表是根据国家税收法律法规及相关规定填报的，我确定它是真实的、可靠的、完整的。</td>
            <td colspan="5">如纳税人填报，由纳税人填写以下各栏：</td>
          </tr>
          <tr>
            <td colspan="5">办税人员（签章）： 财务负责人（签章）： 法定代表人（签章）：刘淑丽 联系电话：</td>
          </tr>
          <tr>
            <td colspan="5">如委托代理人填报，由代理人填写以下各栏：</td>
          </tr>
          <tr>
            <td colspan="5">代理人名称： 经办人（签章）： 联系电话： 代理人（公章）：</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

function watchStart() {
  /*
   单独监听 避免v15x1修改时触发监听
   watch(
    () => data.value.v1x1.value,
    () => {
      data.value.v15x1.value = new Big(data.value.v1x1.value).times(0.03).toNumber();
    }
  ); */

  watch(
    data,
    (newVal, oldVal) => {
      try {
        // 1-22行第3列第4列计算
        for (let row = 1; row <= 22; row++) {
          data.value[`v${row}x3`].value = data.value[`v${row}x1`].value;
          data.value[`v${row}x4`].value = data.value[`v${row}x2`].value;
        }
        // 23-25行第2列计算
        for (let row = 23; row <= 25; row++) {
          data.value[`v${row}x2`].value = data.value[`v${row}x1`].value;
        }

        data.value.v17x1.value = new Big(data.value.v18x1.value).plus(data.value.v19x1.value).round(2).toNumber();
        data.value.v17x2.value = new Big(data.value.v18x2.value).plus(data.value.v19x2.value).round(2).toNumber();

        data.value.v9x1.value = new Big(data.value.v10x1.value).plus(data.value.v11x1.value).plus(data.value.v12x1.value).round(2).toNumber();
        data.value.v9x2.value = new Big(data.value.v10x2.value).plus(data.value.v11x2.value).plus(data.value.v12x2.value).round(2).toNumber();

        data.value.v15x1.value = new Big(data.value.v1x1.value).times(0.03).round(2).toNumber();
        data.value.v15x2.value = new Big(data.value.v1x2.value).times(0.03).round(2).toNumber();

        data.value.v18x1.value = new Big(data.value.v10x1.value).times(0.03).round(2).toNumber();
        data.value.v18x2.value = new Big(data.value.v10x2.value).times(0.03).round(2).toNumber();

        data.value.v20x1.value = new Big(data.value.v15x1.value).minus(data.value.v16x1.value).round(2).toNumber();
        data.value.v20x2.value = new Big(data.value.v15x2.value).minus(data.value.v16x2.value).round(2).toNumber();

        data.value.v22x1.value = new Big(data.value.v20x1.value).minus(data.value.v21x1.value).round(2).toNumber();
        data.value.v22x2.value = new Big(data.value.v20x2.value).minus(data.value.v21x2.value).round(2).toNumber();
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss"></style>

<script>
const tableHtml = `
<table>
  <tbody class="read-mode">
    <tr>
      <td rowspan="16" style="width: 50px"><div style="padding-left: 5px">一 、计税依据</div></td>
      <td rowspan="2" style="width: 470px"><div class="td_xiangmu td_align font-w">项目</div></td>
      <td rowspan="2"><div class="td_lanci td_align font-w" style="width: 40px">栏次</div></td>
      <td colspan="2"><div class="td_bqs td_height td_align font-w">本期数</div></td>
      <td colspan="2"><div class="td_bnlj td_height td_align font-w">本年累计</div></td>
    </tr>
    <tr>
      <td><div class="td_laowu td_height td_align font-w" style="min-width: 45px; line-height: 20px">货物及劳务</div></td>
      <td><div class="td_fuwu td_height td_align font-w" style="line-height: 20px">服务、不动产和无形资产</div></td>
      <td><div class="td_laowu td_height td_align font-w" style="min-width: 45px">货物及劳务</div></td>
      <td><div class="td_fuwu td_height td_align font-w" style="line-height: 20px">服务、不动产和无形资产</div></td>
    </tr>
    <tr class="tr">
      <td><div class="td_height">（一）应征增值税不含税销售额（3%征收率）</div></td>
      <td><div class="td_height td_align">1</div></td>
      <td>
        <div validate="data_1_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_1_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr class="tr">
      <td>
        <div class="td_height indent_2em"><p>增值税专用发票不含税销售额</p></div>
      </td>
      <td><div class="td_height td_align">2</div></td>
      <td>
        <div validate="data_2_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr class="tr">
      <td>
        <div class="td_height indent_2em"><p>其他增值税发票不含税销售额</p></div>
      </td>
      <td><div class="td_height td_align">3</div></td>
      <td>
        <div validate="data_3_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr class="tr">
      <td><div class="td_height">（二）应征增值税不含税销售额（5%征收率）</div></td>
      <td><div class="td_height td_align">4</div></td>
      <td><div class="grid-nocontent">---</div></td>
      <td>
        <div validate="data_4_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr class="tr">
      <td>
        <div class="td_height indent_2em"><p>增值税专用发票不含税销售额</p></div>
      </td>
      <td><div class="td_height td_align">5</div></td>
      <td><div class="grid-nocontent">---</div></td>
      <td>
        <div validate="data_5_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr class="tr">
      <td>
        <div class="td_height indent_2em"><p>其他增值税发票不含税销售额</p></div>
      </td>
      <td><div class="td_height td_align">6</div></td>
      <td><div class="grid-nocontent">---</div></td>
      <td>
        <div validate="data_6_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td><div class="td_height">（三）销售使用过的固定资产不含税销售额</div></td>
      <td><div class="td_height td_align">7(7≥8)</div></td>
      <td>
        <div validate="data_7_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td><div class="td_height indent_2em">其中：其他增值税发票不含税销售额</div></td>
      <td><div class="td_height td_align">8</div></td>
      <td>
        <div validate="data_8_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td><div class="td_height">（四）免税销售额</div></td>
      <td><div class="td_height td_align">9=10+11+12</div></td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td><div class="td_height indent_2em">其中：小微企业免税销售额</div></td>
      <td><div class="td_height td_align">10</div></td>
      <td>
        <div validate="data_10_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_10_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td><div class="td_height indent_4em">未达起征点销售额</div></td>
      <td><div class="td_height td_align">11</div></td>
      <td>
        <div validate="data_11_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_11_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td><div class="td_height indent_4em">其他免税销售额</div></td>
      <td><div class="td_height td_align">12</div></td>
      <td>
        <div validate="data_12_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_12_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td><div class="td_height">（五）出口免税销售额</div></td>
      <td><div class="td_height td_align">13(13≥14)</div></td>
      <td>
        <div validate="data_13_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_13_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td><div class="td_height indent_2em">其中：其他增值税发票不含税销售额</div></td>
      <td><div class="td_height td_align">14</div></td>
      <td>
        <div validate="data_14_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_14_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td rowspan="8"><div class="type" style="padding: 5px">二、税款计算</div></td>
      <td><div class="td_height">本期应纳税额</div></td>
      <td><div class="td_height td_align">15</div></td>
      <td>
        <div validate="data_15_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_15_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td><div class="td_height">本期应纳税额减征额</div></td>
      <td><div class="td_height td_align">16</div></td>
      <td>
        <div validate="data_16_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_16_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td><div class="td_height">本期免税额</div></td>
      <td><div class="td_height td_align">17</div></td>
      <td>
        <div validate="data_17_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_17_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td><div class="td_height indent_2em">其中：小微企业免税额</div></td>
      <td><div class="td_height td_align">18</div></td>
      <td>
        <div validate="data_18_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_18_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td><div class="td_height indent_4em">未达起征点免税额</div></td>
      <td><div class="td_height td_align">19</div></td>
      <td>
        <div validate="data_19_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_19_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td><div class="td_height">应纳税额合计</div></td>
      <td><div class="td_height td_align">20=15-16</div></td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td><div class="td_height">本期预缴税额</div></td>
      <td><div class="td_height td_align">21</div></td>
      <td>
        <div validate="data_21_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_21_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
      <td><div class="grid-nocontent">---</div></td>
    </tr>
    <tr>
      <td><div class="td_height">本期应补（退）税额</div></td>
      <td><div class="td_height td_align">22=20-21</div></td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td><div class="grid-nocontent">---</div></td>
      <td>
        <div class="grid-nocontent"><input type="hidden" name="R0TD1" id="R0TD1" value="0.03" class="ipt" />---</div>
      </td>
    </tr>
    <tr>
      <td rowspan="3"><div class="td_align">三、附加税费</div></td>
      <td><div class="td_height">城市维护建设税本期应补（退）税额</div></td>
      <td><div class="td_height td_align">23</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td><div class="td_height">教育费附加本期应补（退）费额</div></td>
      <td><div class="td_height td_align">24</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td><div class="td_height">地方教育附加本期应补（退）费额</div></td>
      <td><div class="td_height td_align">25</div></td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td colspan="2">
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="2" rowspan="4">
        <div>纳税人或代理人声明：<br />本纳税申报表是根据国家税收法律法规及相关规定填报的，我确定它是真实的、可靠的、完整的。</div>
      </td>
      <td colspan="5"><div class="td_height">如纳税人填报，由纳税人填写以下各栏：</div></td>
    </tr>
    <tr>
      <td colspan="5">
        <div class="td_height"><span>办税人员（签章）：</span> <span style="padding-left: 110px">财务负责人（签章）：</span></div>
        <div class="td_height"><span>法定代表人（签章）：刘淑丽</span> <span style="padding-left: 100px">联系电话：</span></div>
      </td>
    </tr>
    <tr>
      <td colspan="5"><div class="td_height">如委托代理人填报，由代理人填写以下各栏：</div></td>
    </tr>
    <tr>
      <td colspan="5">
        <div class="td_height"><span>代理人名称：</span> <span style="padding-left: 100px">经办人（签章）：</span></div>
        <div class="td_height"><span>联系电话：</span> <span style="padding-left: 110px">代理人（公章）：</span></div>
      </td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input type="text" autocomplete="off" \/>/g, '<el-input-number v-model.trim="defaultValueNum" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValueNum = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
